import React from 'react';
import clsx from 'clsx';
import styles from './styles.module.css';
import { IRegionItem } from 'constants/types';

interface RatingItemProps {
  data: IRegionItem;
}

export const RatingItem = ({ data }: RatingItemProps) => {
  const { icon, name, description } = data;

  return (
    <div className={styles.container}>
      <div className={styles.title_description}>
        <div
          className={clsx(
            styles.item_text,
            name === 'Positive' && styles.positive,
            name === 'Negative' && styles.negative
          )}
        >
          {icon && <div>{icon}</div>}

          {name}
        </div>
        {description && <div className={styles.description}>{description}</div>}
      </div>
    </div>
  );
};
